module.exports = __webpack_public_path__ + "media/images/partners/8_docu-45f77e982048fa528f64ef0381d80994.png";